<template>
  <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditing ? 'Edit Service' : 'Add New Service' }}</h5>
          <button type="button" class="close" aria-label="Close" @click="handleClose">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="item">Item <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="item" v-model="form.item" required>
              </div>
              <div class="form-group col-md-6">
                <label for="type">Type <span class="text-danger">*</span></label>
                <select class="form-control" id="type" v-model="form.type" @change="handleTypeChange" required>
                  <option v-for="option in typeOptions" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

       
            <div v-if="form.type === 'bulk' || form.type === 'hourly'" class="form-row">
              <div class="form-group col-md-12">
                <label for="price">Price (Gross) <span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="form-control" id="price" v-model="form.price" required>
              </div>

            </div>
            <div v-if="form.type === 'per person'" class="form-row">
              <div class="form-group col-md-12">
                <label for="adultPriceGross">Adult Price (Gross)<span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="form-control" id="adultPriceGross" v-model="form.adultPrice_gross"
                  required>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="tax">Tax <span class="text-danger">*</span></label>
                <select class="form-control" id="tax" v-model="form.tax" required>
                  <option v-for="option in taxOptions" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label for="rate">Rate <span class="text-danger">*</span></label>
                <input type="decimal" step="1" class="form-control" id="rate" v-model="form.rate" required>
              </div>
              <div class="form-group col-md-4">
                <label for="category">Category <span class="text-danger">*</span></label>
                <select class="form-control" id="category" v-model="form.category" required>
                  <option v-for="option in categoryOptions" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

            <div class="form-row">

              <div class="form-group col-md-6">
                <label for="remarks">Remarks</label>
                <textarea class="form-control" id="remarks" v-model="form.remarks"></textarea>
              </div>

              <div class="form-group col-md-6">
                <label for="cancellation">Cancellation</label>
                <input type="text" class="form-control" id="cancellation" v-model="form.cancellation">
              </div>
            </div>
            <div class="form-row">

              <div class="form-group col-md-6">
                <label for="year">Year <span class="text-danger">*</span></label>
                <select class="form-control" id="year" v-model="form.year" required>
                  <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="supplier">Supplier <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="supplier" v-model="form.supplier" required>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="cities">Select City</label>
                <select class="form-control" id="cities" v-model="selectedCity">
                  <option v-for="city in cityOptions" :key="city.value" :value="city.value">
                    {{ city.text }}
                  </option>
                </select>
                <button type="button" class="btn btn-secondary mt-2" @click="addCity">+</button>
                <div class="form-group mt-2">
                  <label>Selected Cities</label>
                  <div class="selected-cities">
                    <div class="city-item" v-for="(city, index) in form.cities" :key="index">
                      {{ getCityName(city.id) }}
                      <b-button size="sm" class="remove-btn" @click="removeCity(index)">
                        <i class="fas fa-trash"></i>
                      </b-button>
                    </div>
                  </div>
                  <div v-if="cityError" class="text-danger">Please select at least one city.</div>
                </div>
              </div>


            </div>
            <button type="submit" class="btn btn-primary">{{ isEditing ? 'Update' : 'Submit' }}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    service: Object,
    cities: {
      type: Array,
    }
  },
  data() {
    const startYear = 2024;
    return {
      form: {
        item: '',
        adultPrice_net: null,
        price: '',
        type: '',
        tax: '',
        rate: null,
        adultPrice_gross: null,
        category: '',
        remarks: '',
        cancellation: '',
        year: null,
        cities: [],
        supplier: ''
      },
      yearOptions: Array.from({ length: 5 }, (v, i) => startYear + i), // Starting from 2024, going forward 20 years

      selectedCity: null,
      typeOptions: ['per person', 'bulk', 'hourly'],
      taxOptions: ['Toms', 'VAT', 'Rcv'],
      categoryOptions: ['Accommodation', 'F&B', 'Staff', 'Transportation', 'Insides', 'Additional Services'],
      cityOptions: [],
      cityError: false
    };
  },
  computed: {
    isEditing() {
      return this.service !== null;
    }
  },
  mounted() {
    this.fetchCities();
    if (this.isEditing && this.service) {
      this.form = {
        ...this.service.attributes,
        cities: Array.isArray(this.service.attributes.cities?.data) 
          ? this.service.attributes.cities.data.map(city => ({ id: city.id })) 
          : []
      };
    }
  },

  methods: {
    async fetchCities() {
      try {
        const response = await this.$xhr.get('/api/cities?pagination[pageSize]=1000&sort[0]=city:asc');
        this.cityOptions = response.data.data.map(city => ({
          value: city.id,
          text: city.attributes.city
        }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },

    handleTypeChange() {
      if (this.form.type === 'bulk' || this.form.type === 'hourly') {
        this.form.adultPrice_net = null;
        this.form.adultPrice_gross = null;
      } else if (this.form.type === 'per person') {
        this.form.price = null;
      }
    },
    handleClose() {
      this.$emit('close');
    },
    addCity() {
      if (this.selectedCity) {
        this.form.cities.push({ id: this.selectedCity });
        this.selectedCity = null;  // Reset the dropdown
        this.cityError = false;  // Reset error state
      } else {
        this.cityError = true;
      }
    },
    removeCity(index) {
      this.form.cities.splice(index, 1);
    },
    getCityName(cityId) {
      const city = this.cities.find(city => city.id === cityId);
      return city ? city.attributes.city : 'Unknown';
    },
    normalizePrice(value) {
      if (typeof value === 'string') {
        return value.replace(',', '.');
      }
      return value;
    },
    async submitForm() {
      this.cityError = false;

      if (this.form.cities.length === 0 || this.form.cities.some(city => !city.id)) {
        this.cityError = true;
        this.$bvToast.toast('Please select at least one city.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (!this.isEditing) {
    const itemExists = await this.checkItemExists(this.form.item, this.form.year);
    if (itemExists) {
      this.$bvToast.toast('An item with the same name already exists for the selected year.', {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
      return;
    }
  }

      if (this.form.type === 'per person') {
        this.form.adultPrice_gross = this.normalizePrice(this.form.adultPrice_gross);
        if (this.form.tax === 'Toms') {
          this.form.adultPrice_net = Number(this.form.adultPrice_gross).toFixed(2);
        } else {
          const rateMultiplier = 1 + (Number(this.form.rate) / 100);
          this.form.adultPrice_net = (Number(this.form.adultPrice_gross) / rateMultiplier).toFixed(2);
        }
      } else {
        this.form.price = this.normalizePrice(this.form.price);
      }

      const formData = {
        ...this.form,
        cities: this.form.cities.map(city => city.id)
      };

      if (this.isEditing) {
        await this.$xhr.put(`/api/servicerivers/${this.service.id}`, { data: formData });
      } else {
        await this.$xhr.post('/api/servicerivers', { data: formData });
      }

      this.$emit('service-added');
      this.handleClose();
    },

    async checkItemExists(item, year) {
  try {
    const response = await this.$xhr.get(`/api/servicerivers?filters[item][$eq]=${item}&filters[year][$eq]=${year}`);
    return response.data.data.length > 0;
  } catch (error) {
    console.error("Error checking item existence:", error);
    return false;
  }
}

  }
};
</script>



<style scoped>
.modal-content {
  margin: 10px auto;
}

.modal-dialog-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 50%;
}

.modal-body {
  max-height: 90vh;
  overflow-y: auto;
}

.remove-btn {
  background-color: red;
  color: white;
  margin-left: 1rem;
}

.selected-cities {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}

.city-item {
  width: calc(20% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: #f8f9fa;
  padding: 0.5rem;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
